var _rect, _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 47,
    rx: 7,
    fill: "url(#paint0_linear_937_2449)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0003 21.1667C28.633 21.1667 34.3337 19.2202 34.3337 15.5C34.3337 11.7798 28.633 9.83334 23.0003 9.83334C17.3677 9.83334 11.667 11.7798 11.667 15.5C11.667 19.2202 17.3677 21.1667 23.0003 21.1667Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.667 21.1667C11.667 24.8868 17.3677 26.8333 23.0003 26.8333C28.633 26.8333 34.3337 24.8868 34.3337 21.1667V18.3333C34.3337 22.0535 28.633 24 23.0003 24C17.3677 24 11.667 22.0535 11.667 18.3333V21.1667Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.667 26.8333C11.667 30.5535 17.3677 32.5 23.0003 32.5C28.633 32.5 34.3337 30.5535 34.3337 26.8333V24C34.3337 27.7202 28.633 29.6667 23.0003 29.6667C17.3677 29.6667 11.667 27.7202 11.667 24V26.8333Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.667 32.5C11.667 36.2202 17.3677 38.1667 23.0003 38.1667C28.633 38.1667 34.3337 36.2202 34.3337 32.5V29.6667C34.3337 33.3868 28.633 35.3333 23.0003 35.3333C17.3677 35.3333 11.667 33.3868 11.667 29.6667V32.5Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_937_2449",
    x1: 23.5,
    y1: 0,
    x2: 23.5,
    y2: 47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBCE8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#695020"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoin);
export default __webpack_public_path__ + "static/media/coin.255f648dbe32a3f53150107b47500ad1.svg";
export { ForwardRef as ReactComponent };